module.exports = __webpack_public_path__ + "img/IMG-20200809-WA0013.949c94ee.jpg";